import { Routes } from '@angular/router'
import { AuthGuard } from './guards/auth.guard'

import { LoginComponent } from './components/login/login.component'
import { RememberPasswordComponent } from './components/remember-password/remember-password.component'
import { ResetPasswordComponent } from './components/reset-password/reset-password.component'
import { PanelComponent } from './components/protected/panel/panel.component'
import { AdminComponent } from './components/protected/admin/admin.component'
import { CompanyComponent } from './components/protected/company/company.component'
import { UserDetailComponent } from './components/protected/user-detail/user-detail.component'
import { AdminResolver } from './components/protected/admin/admin.resolver'
import { CompanyResolver } from './components/protected/company/company.resolver'
import { BotanicComponent } from './components/protected/botanic/botanic.component'
import { CompanyAdminComponent } from './components/protected/company-admin/company-admin.component'
import { RedirectComponent } from './components/protected/redirect/redirect.component'
import { SchedulerComponent } from './components/protected/scheduler/scheduler.component'
import { DemandsHistoryComponent } from './components/protected/demands-history/demands-history.component'
import { SpeciesComponent } from './components/protected/species/species.component'
import { StepsComponent } from './components/protected/scheduler/steps/steps.component'
import { EvaluationComponent } from './components/protected/evaluation/evaluation.component'
import { EvaluationResolver } from './components/protected/evaluation/evaluation.resolver'
import { DemandsHistoryResolver } from './components/protected/demands-history/demands-history.resolver'
import { HandlerOperationComponent } from './components/protected/handler-operation/handler-operation.component'
import { HandlerOperationResolver } from './components/protected/handler-operation/handler.operation.resolver'
import { ManagementConfigurationComponent } from './components/protected/management-configuration/management-configuration.component'
import { ManagementConfigurationResolver } from './components/protected/management-configuration/management-configuration.resolver'
import { OperationServiceComponent } from './components/protected/operation-service/operation-service.component'
import { OperationServiceResolver } from './components/protected/operation-service/operation-service.resolver'
import { OperatorSchedulingComponent } from './components/protected/operation-service/operator-scheduling/operator-scheduling.component'
import { OperationServiceHistoryComponent } from './components/protected/operation-service-history/operation-service-history.component'
import { OperationServiceReportArborealComponent } from './components/protected/operation-service-report-arboreal/operation-service-report-arboreal.component'
import { DashboardComponent } from './components/protected/dashboard/dashboard.component'
import { PublicPanelComponent } from './components/protected/central-control/public-panel/public-panel.component'
import { DataCsvComponent } from './components/protected/data-csv/data-csv.component'
import { RealtimeLocationComponent } from './components/protected/realtime-location/realtime-location.component'
import { SchedulerInventoryComponent } from './components/protected/scheduler-inventory/scheduler-inventory.component'
import { HistoryInventoryComponent } from './components/protected/history-inventory/history-inventory.component'
import { SpeciesResolver } from './components/protected/species/species.resolver'
import { ValidationReportComponent } from './components/validation-report/validation-report.component'
import { SchedulerPlantingComponent } from './components/protected/scheduler-planting/scheduler-planting.component'
import { HistoryPlantingComponent } from './components/protected/history-planting/history-planting.component'
import { GeneralFeatures } from './components/protected/scheduler-planting/general-features/general-features.component'
import { CompanyServiceProviderComponent } from './components/protected/company-service-provider/company-service-provider.component'
import { PrivacyComponent } from './components/privacy/privacy.component'
import { CommunicationAppraisal } from './components/protected/communication-appraisal/communicationAppraisal.component'
import { RegionsComponent } from './components/protected/regions/regions.component'
import { InventoryReportArborealComponent } from './components/protected/inventory-report-arboreal/inventory-report-arboreal.component'
import { PlantingReportArborealComponent } from './components/protected/planting-report-arboreal/planting-report-arboreal.component'
import { PlantingOpportunityReportArborealComponent } from './components/protected/plantingOpportunity-report-arboreal/plantingOpportunity-report-arboreal.component'
import { OperationServiceScheduleReportArborealComponent } from './components/protected/operation-service-schedule-report-arboreal/operation-service-schedule-report-arboreal.component'
import { RequestersComponent } from './components/protected/requesters/requesters.component'
import { PreScheduleInventoryComponent } from './components/protected/scheduler-inventory/pre-schedule/pre-scheduling-inventory.component'
import { PreScheduleOperationServiceComponent } from './components/protected/operation-service/pre-scheduling/operation-service-pre-scheduling.component'
import { AppraisalReportComponent } from './components/protected/evaluation-reports/appraisal/appraisal-report.component'

export const ROUTES: Routes = [
	{ path: '', redirectTo: 'login', pathMatch: 'full' },
	{ path: 'privacy', component: PrivacyComponent, pathMatch: 'full'},
	{ path: 'login', component: LoginComponent, pathMatch: 'full', canActivate: [AuthGuard]},
	{ path: 'datacsv', component: DataCsvComponent, pathMatch: 'full' },
	{
		path: 'validation',
		component: ValidationReportComponent,
		pathMatch: 'full'
	},
	{
		path: 'remember-password',
		component: RememberPasswordComponent,
		pathMatch: 'full'
	},
	{
		path: 'reset-password',
		component: ResetPasswordComponent,
		pathMatch: 'full'
	},
	{ path: 'redirect', component: RedirectComponent, pathMatch: 'full', canActivate: [AuthGuard]},
	{
		path: 'protected/evaluationReportArboreal/:appraisalIds',
		component: AppraisalReportComponent,
		pathMatch: 'full',
		canActivate: [AuthGuard]
	},
	{
		path: 'protected/communicationAppraisal/:appraisalIds',
		component: CommunicationAppraisal,
		pathMatch: 'full',
		canActivate: [AuthGuard]
	},
	{
		path: 'protected/operationReportArboreal',
		component: OperationServiceReportArborealComponent,
		pathMatch: 'full',
		canActivate: [AuthGuard]
	},
	{
		path: 'protected/operationServiceScheduleReportArboreal/:operationsId',
		component: OperationServiceScheduleReportArborealComponent,
		pathMatch: 'full',
		canActivate: [AuthGuard]
	},
	{
		path: 'protected/inventoryReportArboreal/:inventoryIds',
		component: InventoryReportArborealComponent,
		pathMatch: 'full',
		canActivate: [AuthGuard]
	},
	{
		path: 'protected/plantingOpportunityReportArboreal/:plantingsOpportunityIds',
		component: PlantingOpportunityReportArborealComponent,
		pathMatch: 'full',
		canActivate: [AuthGuard]
	},
	{
		path: 'protected/plantingReportArboreal/:plantingIds',
		component: PlantingReportArborealComponent,
		pathMatch: 'full',
		canActivate: [AuthGuard]
	},
	{
		path: 'panel',
		component: PanelComponent,
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		children: [
			// Inventário
			{
				path: 'inventory/schedulerInventory',
				component: SchedulerInventoryComponent,
				pathMatch: 'full'
			},
			{
				path: 'inventory/historyInventory',
				component: HistoryInventoryComponent,
				pathMatch: 'full'
			},

			// Plantio

			{
				path: 'planting/scheduler-planting',
				component: SchedulerPlantingComponent,
				pathMatch: 'full'
			},
			{
				path: 'planting/history-planting',
				component: HistoryPlantingComponent,
				pathMatch: 'full'
			},
			{
				path: 'planting-operation/operation',
				component: GeneralFeatures,
				pathMatch: 'full'
			},
			// Manejo
			{
				path: 'management/operationService',
				component: OperationServiceComponent,
				pathMatch: 'full'
			},
			{
				path: 'management/operationHistory',
				component: OperationServiceHistoryComponent,
				pathMatch: 'full'
			},

			// Avaliação
			{
				path: 'appraisal/scheduler',
				component: SchedulerComponent,
				pathMatch: 'full'
			},
			{
				path: 'appraisal/demandsHistory',
				component: DemandsHistoryComponent,
				pathMatch: 'full',
				resolve: { demands: DemandsHistoryResolver }
			},
			// General Admin
			{
				path: 'admin',
				component: AdminComponent,
				pathMatch: 'full',
				resolve: { admins: AdminResolver }
			},
			{
				path: 'company',
				component: CompanyComponent,
				pathMatch: 'full',
				resolve: { companies: CompanyResolver }
			},
			{
				path: 'requester',
				component: RequestersComponent,
				pathMatch: 'full'
			},
			{
				path: 'companyServiceProvider',
				component: CompanyServiceProviderComponent,
				pathMatch: 'full'
			},
			{
				path: 'botanic',
				component: BotanicComponent,
				pathMatch: 'full'
			},
			{
				path: 'species',
				component: SpeciesComponent,
				pathMatch: 'full',
				resolve: { species: SpeciesResolver }
			},

			// Public
			{
				path: 'userDetail',
				component: UserDetailComponent,
				pathMatch: 'full'
			},

			// Others

			{
				path: 'realtimeLocation',
			 	component: RealtimeLocationComponent,
				pathMatch: 'full'
			},
			{
				path: 'user',
				component: CompanyAdminComponent,
				pathMatch: 'full'
			},
			{
				path: 'managementConfiguration',
				component: ManagementConfigurationComponent,
				pathMatch: 'full',
				resolve: {
					managementConfiguration: ManagementConfigurationResolver
				}
			},
			{
				path: 'central-control/dashboard',
				component: DashboardComponent,
				pathMatch: 'full'
			},
			{
				path: 'central-control/public-panel',
				component: PublicPanelComponent,
				pathMatch: 'full'
			},
			{
				path: 'regions',
				component: RegionsComponent,
				pathMatch: 'full'
			},
			{
				path: 'inventory/pre-schedule',
				component: PreScheduleInventoryComponent,
				pathMatch: 'full'
			},
			{
				path: 'operation/pre-schedule',
				component: PreScheduleOperationServiceComponent,
				pathMatch: 'full'
			},
			{
				path: 'operation/schedule',
				component: OperatorSchedulingComponent,
				pathMatch: 'full'
			},
			{
				path: 'evaluations',
				component: EvaluationComponent,
				pathMatch: 'full',
				resolve: { evaluations: EvaluationResolver }
			},
			{
				path: 'appraisal/evaluation/steps',
				component: StepsComponent,
				pathMatch: 'full'
			},
			{
				path: 'operations',
				component: HandlerOperationComponent,
				pathMatch: 'full',
				resolve: { operations: HandlerOperationResolver }
			}
		]
	},
	{ path: '**', redirectTo: 'login' }
]
